define(function (require) {

	const CodeDefinitionCollection = require('civicsCollections/code_definition_collection');
	const ViewManager = require('civicsUtils/view_manager');
	const CN = require('civicsUtils/constants');
	const utils = require('civicsUtils/general_utilities');
	const DataModelStore = require('civicsBase/data_model_store');

	return {
		types: [],
		fetchApplicantTypes: function (instType) { // fetch applicant type from rest service
			var applicantTypesPromise = $.Deferred();
			var self = this;
			var applicantTypes = new CodeDefinitionCollection();
			applicantTypes.instrumentType = instType;
			applicantTypes.comparator = function (a) {
				var aSort = a.get('description');
				return aSort.toLowerCase();
			};
			applicantTypes.fetch({
				error: function (model, response, options) {
					ViewManager.errorToWindow(response, this);
				}
			}).done(function (response, status, xhrResponse) {
				self.types = response.data.codeDescriptionItems.filter((item) => {
					return item.code != 'None';
				});
				applicantTypesPromise.resolve();
			});
			return applicantTypesPromise;
		},
		getApplicantTypes: function (instType) {
			var applicantTypesList = new CodeDefinitionCollection();
			if (this.types.length == 0) {
				var apps = CN.APPLICANT_TYPES()[instType.toLowerCase()];
				var ret = [];
				$.each(apps, function (index, el) {
					if (!$.isEmptyObject(el)) {
						ret.push(el);
					}
				});
				ret.sort(function (a, b) {
					if (a.description.toLowerCase() > b.description.toLowerCase()) {
						return 1;
					} else if (a.description.toLowerCase() == b.description.toLowerCase()) {
						return 0;
					} else {
						return -1;
					}
				});
				applicantTypesList.set(ret);
				return applicantTypesList;
			} else {
				applicantTypesList.set(this.types);
				return applicantTypesList;
			}
		},
		getApplicantTypeDesc: function (code, instType, types, appTypeDesc) {
			var globalConfig = ViewManager.globalConfig();
			if (instType.toLowerCase() != 'tradelicense' && globalConfig.get("usesApplicantType") != null && globalConfig.get("usesApplicantType").toLowerCase() == "show") {
				if (appTypeDesc) {
					return appTypeDesc; //for applicant item, invitation item
				}
				if (types != undefined && types.length > 0) { //if it's a number or code(e.g PropertyOwner)
					return utils.getApplicantTypeDescription(code, instType, types);
				}
			} else {
				return ""
			}
		},
		/**
		 * Check if the two str exactly matches or if filterMoniker contains a value of viewRecordType.
		 * @param {string} filterMoniker - Business Object Moniker of the filter code.
		 * @param {string} viewRecordType - Type of record that the current view caters.
		 * @returns boolean
		 */
		compareFilterMonikerType: function (filterMoniker, viewRecordType) {
			//need extra parameter that tells if we want to do exact match or contains or all
			let retValue = false;
			if (filterMoniker !== undefined && viewRecordType !== undefined) {

				filterMoniker = filterMoniker.toLowerCase();
				viewRecordType = viewRecordType.toLowerCase();

				if (filterMoniker === viewRecordType || filterMoniker.indexOf(viewRecordType) !== -1) {
					retValue = true;
				}
			}

			return retValue;
		},
		/**
		 * Check to see if the filterMoniker is available in the list of applicable filter code setup. 
		 * filter code list in the page
		 * @param {string} filterMoniker - moniker of the fiter code that is to be applied.
		 * @returns -  true or false value.
		 * @example
		 * FilterCodesList.list = ["building", "InforClient.MyRhythmDetailPage.Form1", "InforClient.MyRhythmDetailPage.Form2"]
		 * Utils.formTypeSupported("InforClient.MyRhythmDetailPage.Form1") //true
		 * Utils.formTypeSupported("Building") //true
		 * Utils.formTypeSupported("License") //false
		 */
		trackFilterCodeSetupList: function(filterMoniker) {
			let retValue = false;


			let FilterCodeSetupList = DataModelStore.get("FilterCodesList", "list");

			if (FilterCodeSetupList && _.isArray(FilterCodeSetupList)) {
				FilterCodeSetupList.forEach(element => {
					if (this.compareFilterMonikerType(filterMoniker, element) === true) {
						retValue = true;
					}
				});
			}

			return retValue;
		}
	};
});
